import { isString, toLocalDateString } from "@hex-insights/core";
import {
	AcademicTerm,
	StudentAcademicTermEnrollment,
	StudentAcademicTermEnrollmentFilterInput,
} from "../../../Utilities";
import * as ModelUtilities from "../_General";

export function isActive(
	enrollment: Pick<StudentAcademicTermEnrollment, "lateStartDate" | "earlyEndDate">,
	date?: Date,
) {
	return ModelUtilities.isEnrollmentActive(enrollment, date);
}

export function getEnrolledOnDateFilter(date: Date | string = new Date()): StudentAcademicTermEnrollmentFilterInput {
	const dateISO = isString(date) ? date : toLocalDateString(date);
	return {
		academicTerm: [
			{
				startDateLTE: dateISO,
				endDateGTE: dateISO,
			},
		],
		and: [
			{
				or: [{ lateStartDateIsNull: true }, { lateStartDateLTE: dateISO }],
			},
			{
				or: [{ earlyEndDateIsNull: true }, { earlyEndDateGTE: dateISO }],
			},
		],
	};
}

export function getEnrolledInAcademicTermOnDateFilter(
	academicTermID: AcademicTerm["id"],
	date: Date | string = new Date(),
): StudentAcademicTermEnrollmentFilterInput {
	const dateISO = isString(date) ? date : toLocalDateString(date);
	return {
		academicTermIDEQ: academicTermID,
		and: [
			{
				or: [{ lateStartDateIsNull: true }, { lateStartDateLTE: dateISO }],
			},
			{
				or: [{ earlyEndDateIsNull: true }, { earlyEndDateGTE: dateISO }],
			},
		],
	};
}
